const setWindowWidth = ({ commit }, payload) =>
  new Promise(resolve => {
    commit("SET_WINDOW_WIDTH", payload);
    resolve();
  });

const setSidebarStatus = ({ commit }, payload) =>
  new Promise(resolve => {
    commit("SET_SIDEBAR_STATUS", payload);
    resolve();
  });

export default {
  setWindowWidth,
  setSidebarStatus
};
